<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">Customer Agreement</div>
    </div>
    <div class="action_btn">
      <button class="btn primary_button" (click)="addNewCustomerAgreement()" *RequiresPermission="{permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.CREATE]}">
        <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
        New Agreement
      </button>

    </div>
  </div>
</header>

<div class="search_bar_with_table" *RequiresPermission="{permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.LIST]};fallback: true">
  <div class="content">
    <app-tos-table
      [showTableStats]="false"
      [searchBarConfig]="searchBarConfig"
      [filterConfig]="CustomerAgreementListingTableConfig.filterConfig"
      [tableMeta]="tableMeta"
      [tableMenuOptions]="menuOptions"
      [(dataListRequest)]="tableListRequest"
      [dataListResponse]="tableListData"
      [(selectedItems)]="selectedItems"
      (tosTableAction)="getTableList()"
      (tableMenuOptionSelected)="handleOptionSelected($event)"
      (rowActionTriggered)="handleRowAction($event)"
    >
    </app-tos-table>
  </div>
</div>


<ng-template #customerAgreementCloneForm let-data>
  <div class="clone_form">
    <app-file-upload
      [(files)]="selectedFiles"
      [multiFileUpload]="true"
    ></app-file-upload>
    <app-dynamic-form
      [formConfig]="customerAgreementFormConfig"
      [formGroup]="customerAgreementForm"
    ></app-dynamic-form>
    <div class="action_buttons">
      <button class="secondary_button" (click)="closeModal()">Cancel</button>
      <button class="primary_button" (click)="save(data?.record)">Save</button>
    </div>
  </div>
</ng-template>
